export default __webpack_public_path__ + "static/tag-dont-2-dark-bb757f42829d09f6cae0cbba71239c605f43971e8f14ce2dcdc2e212e1a18b5d.png";